import { Column, Entity, Index, JoinColumn, OneToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { UserEntity } from './user.entity';

@Index('user_client_restrictions_pk', ['fkUserId'], { unique: true })
@Entity('user_client_restrictions')
export class UserClientRestrictionsEntity extends BaseEntity {
	@Column('text', { name: 'clientQueryFilter', nullable: true })
	public clientQueryFilter!: string | null;

	@Column('int', { name: '_fk_user__id', unique: true, unsigned: true })
	public fkUserId!: number;

	@OneToOne(() => UserEntity, (user) => user.userClientRestrictions, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_user__id', referencedColumnName: 'id' }])
	public fkUser!: UserEntity;
}
